import { cn } from '@/utils/cn';

const baseTextContainerClasses = 'h-[18px] px-1 bg-[#f4f4f4] rounded-[3px] outline outline-[0.50px] outline-offset-[-0.50px] outline-[#dddddd] inline-flex justify-center items-center align-middle';
const baseTextClasses = 'text-[#111111] text-sm font-black leading-none';
const baseImageClasses = 'h-[16px] w-auto inline-block align-middle object-contain';

const RarityBadge = ({ rarity, className = '', textClassName = '', imageClassName = '', ...props }) => {
  if (!rarity) return null;

  if (rarity.icon?.url) {
    return (
      <img
        src={rarity.icon.url}
        alt={rarity.name || 'rarity icon'}
        className={cn(baseImageClasses, className, imageClassName)}
        {...props}
      />
    );
  }

  if (!rarity.name) {
    return null;
  }

  return (
    <span className={cn(baseTextContainerClasses, className)} {...props}>
      <span className={cn(baseTextClasses, textClassName)}>{rarity.name}</span>
    </span>
  );
};

export default RarityBadge;
